import { ThemeScope } from "./constants"

export const state = {
  scope: ThemeScope.CLIENT,
  /** @type {(import('../types').Theme | null)} */
  theme: null
}
